/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import { isAdmin } from '../../../../../../permissions/general.js';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AllocateAssetToProjectSuccess extends React.Component<*> {
  render(): React.Node {
    const { t, actionDrawerStore, response }: TypeProps = this.props;
    const isUserAdmin: boolean = isAdmin();

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>
              {isUserAdmin
                ? t('general:assets.allocated')
                : t('general:assets.messages.allocation_request_pending')}
            </h3>
            <p>
              {isUserAdmin
                ? t('general:assets.messages.project_allocation_success')
                : t('general:assets.messages.project_allocation_review')}
            </p>
            {!isUserAdmin && <p>{t('general:assets.messages.project_allocation_notification')}</p>}
            <ul>
              <li>
                <b>{t('general:asset')}:</b>
              </li>
              <li>{`${response.asset_number}, ${response.manufacturer}, ${response.model}`}</li>
            </ul>
            <ul>
              <li>
                <b>{t('general:project')}:</b>
              </li>
              <li>{`${response.project_code}, ${response.project_name}`}</li>
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
